import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/components/ui/carousel";
import Autoplay from "embla-carousel-autoplay";

import banner1 from "@/images/home/banner-1.jpg";
import banner2 from "@/images/home/banner-happy-new-year.jpg";
import banner3 from "@/images/home/banner-3.jpg";
import { Section } from "@/components/ui/section";
import { Link } from "@inertiajs/react";

const banners = [
  {
    link: null,
    image: banner1,
  },
  {
    link: '/t/categories/roznichnyi-sait/?filter%5Bproperties%5D%5Btematika%5D=novogodnyaya',
    image: banner2,
  },
  {
    link: "/content/delivery-and-payment",
    image: banner3,
  },
];

export default function BannersCarousel() {
  return (
    <Carousel
      className="max-sm:overflow-hidden"
      opts={{ loop: true }}
      plugins={[Autoplay({ delay: 3000 })]}
    >
      <CarouselContent>
        {banners.map((banner, i) => (
          <CarouselItem key={`carousel-item-${i}`} className="basis-3/4 lg:basis-1/2 xl:basis-1/3">
            {banner.link ? (
              <Link href={banner.link}>
                <img
                  src={banner.image}
                  className="h-22 xl:h-40 w-full rounded-xl object-cover"
                />
              </Link>

            ) : (
              <img
                  src={banner.image}
                  className="h-22 xl:h-40 w-full rounded-xl object-cover"
                />
            )}
          </CarouselItem>
        ))}
      </CarouselContent>
      <CarouselPrevious className="max-sm:left-2 max-sm:bg-transparent max-sm:text-white max-sm:size-6" />
      <CarouselNext className="max-sm:right-2 max-sm:bg-transparent max-sm:text-white max-sm:size-6" />
    </Carousel>
  );
}
